<wuc-button type="clean" e2e="modal_close" modal-close-btn>
    <wuc-icon-ui icon="cross-closed"></wuc-icon-ui>
</wuc-button>

<h2 modal-title>Uw motorverzekering en schadevrije jaren</h2>
<div modal-content>
    <p>
        Bij het afsluiten van uw motorverzekering vragen wij naar de door u opgebouwde schadevrije jaren. Op basis van
        uw schadevrije jaren krijgt u bij de meeste verzekeraars korting op de premie van uw motorverzekering.
    </p>

    <wuc-accordion>
        <wuc-accordion-item>
            <span slot="title">Hoe werken schadevrije jaren bij een motor?</span>
            <p>
                Schadevrije jaren zijn een soort bewijs van goed gedrag. Hoe meer schadevrije jaren (jaren waarin u
                wel verzekerd was, maar geen schade heeft geclaimd) u heeft, hoe hoger de korting op uw premie.
                Claimt u een jaar lang geen schade op uw motorverzekering? Dan krijgt u van ons een schadevrij jaar
                toegekend. Maakt u wel schade? Dan moet u 5 jaren inleveren. Heeft u 11 of meer schadevrije en
                claimt u een schade? Dan gaat u terug naar 5 schadevrije jaren.
            </p>
        </wuc-accordion-item>
        <wuc-accordion-item>
            <span slot="title">Eerder opgebouwde schadevrije jaren meenemen</span>
            <p>
                Wie weet heeft u uw auto wel ingeruild voor een motor of bent u al een tijdje ergens anders
                verzekerd. Het zou natuurlijk zonde zijn als u de schadevrije jaren die u ergens anders al heeft
                opgebouwd, niet mee zou kunnen nemen naar uw
                <wuc-link url="/motorverzekering">Motorverzekering</wuc-link>
                bij InShared.
            </p>
        </wuc-accordion-item>
        <wuc-accordion-item>
            <span slot="title">Twee motoren?</span>
            <p>
                Je hebt een hobby of niet. Misschien wilt u wel twee motoren bij ons verzekeren. Als u op de ene
                motor minder schadevrije jaren heeft dan op het andere, kan de tweede toch profiteren van de korting
                van de eerste. Volgt u het nog? Dat heet de tweede voertuigregeling. U vult bij uw eerste motor het
                aantal schade vrije jaren in dat u heeft opgebouwd op dat kenteken en bij de tweede ook. Wij checken
                dan voor u wat het meest gunstig is en geven u ook voor de tweede motor dezelfde korting op de
                premie! LET OP: Als u bij ons weggaat, moeten we jammer genoeg gewoon het daadwerkelijke aantal
                schadevrije jaren voor dat kenteken in Roy Data zetten en krijgt u bij uw nieuwe verzekeraar
                waarschijnlijk niet dezelfde korting meer.
            </p>
        </wuc-accordion-item>
        <wuc-accordion-item>
            <span slot="title">Al een auto bij ons verzekerd?</span>
            <p>
                Heeft u al een auto bij ons verzekerd en wilt u nu graag uw motor ook bij ons verzekeren? Ook dan
                kunt u profiteren van een hogere korting op uw Motorverzekering. Bij het afsluiten van de
                Motorverzekering vult u de schadevrije jaren van uw lopende Autoverzekering bij InShared in. Zodra
                de Motorverzekering is ingegaan, stuurt u ons via het contactformulier een mailtje. Wij geven u dan
                de korting die hoort bij het aantal schadevrije jaren van uw Autoverzekering. Los van de korting
                bouwt u met uw motor gewoon schadevrije jaren op vanaf waar u was. En als u ooit bij ons weggaat,
                zetten we die daadwerkelijk opgebouwde jaren in Roy-data.
            </p>
        </wuc-accordion-item>
        <wuc-accordion-item>
            <span slot="title">Meenemen vanaf een andere verzekeraar</span>
            <p>
                Ook als u van een andere verzekeraar overstapt naar InShared, kunt u uw opgebouwde jaren gewoon
                meenemen. Vul bij het aanvragen van de verzekering gewoon het aantal schadevrije jaren in.
            </p>
        </wuc-accordion-item>
        <wuc-accordion-item>
            <span slot="title">Registratie in Roy-data</span>
            <p>
                Het aantal schadevrije jaren dat op uw naam staat wordt goed bijgehouden in een centrale database.
                In de zogenaamde Roy-data houden alle verzekeraars bij wie hoeveel schadevrije jaren heeft. Wij
                controleren dan ook altijd of het aantal schadevrije jaren dat u heeft opgegeven klopt met de
                gegevens in Roy-data. Als dat niet zo is, kan dat invloed hebben op uw premie. Hier krijgt u dan
                altijd eerst een e-mail over.
            </p>
        </wuc-accordion-item>
    </wuc-accordion>
</div>
